import React from "react";

const AdvisoryCommitteeCard = (props) => {
  const { img, name, por } = props;
  return (
    <div className="flex flex-col rounded-lg items-center mt-6 w-[280px] ">
      <div className="h-[18rem] w-full">
        <img src={img} className="w-full h-full rounded-lg" alt="" />
      </div>
      <div className="bg-[#f1f1f5] flex flex-col items-center text-[#000] py-1 px-2 w-full flex-1">
        <span
          className="text-[25px] font-medium"
          style={{ fontFamily: "Roboto Condensed" }}
        >
          {name}
        </span>
        <span className="text-xl font-light text-center">{por}</span>
      </div>
    </div>
  );
};

export default AdvisoryCommitteeCard;
